/**
 * Check for Window Hash on Load + load in content if applicable
 * @author Matt Haynes
 * @package Dunfermline
 */

import UpdateContent from './UpdateContent';

let currDisplay;
const CheckHashOnLoad = (tourData, pageData, contentBody) => {
    const windowHash = window.location.hash || null;

    const map = document.getElementById('map');
    const tourContainer = document.getElementById('tour_container');
    const contentSection = document.querySelector('.content-section');
    const landingBody = document.getElementById('landing_content');
    const tourBody = document.getElementById('tour_content');
    const initialInfo = document.querySelector('.initial-information');
    const continueToTour = document.querySelector('.continue-tour');
    const toggleContent = document.getElementById('toggle_content');
    // eslint-disable-next-line
    const controlButtons = Array.from(document.querySelectorAll('.tour_content__contentButton'));
    const markVisited = document.getElementById('visited');
    const spotifyPlayer = document.getElementById('spotify-player');
    const audioContainer = document.getElementById('audio-container');
    const audioPlayer = document.getElementById('audio-player');
    const locationContinueButton = document.getElementById('location-continue');
    const locationContinueContainer = document.getElementById('location');

    for (let i = 0, n = tourData.length; i < n; i += 1) {
        if (`#${tourData[i].slug}` === windowHash && windowHash) {
            tourContainer.classList.remove('toggled');
            contentSection.classList.remove('toggled');
            contentSection.classList.add('tour-started');
            initialInfo.classList.add('hide');
            continueToTour.classList.add('hide');
            tourBody.querySelector('.tour-content').classList.remove('hide');
            toggleContent.classList.remove('hide');
            controlButtons.forEach(button => button.classList.remove('hide'));
            markVisited.classList.remove('hide');
            controlButtons.forEach(button => button.classList.remove('hide'));
            markVisited.classList.remove('hide');
            if (spotifyPlayer && spotifyPlayer.getAttribute('data-src').length > 0) {
                spotifyPlayer.classList.remove('hide');
                spotifyPlayer.classList.remove('init-hide');
            }
            if (audioContainer && audioPlayer.src.length > 0) {
                audioContainer.classList.remove('hide');
                audioContainer.classList.remove('init-hide');
            }
            map.classList.remove('init');
            tourContainer.classList.add('toggled');
            contentSection.classList.add('toggled');
            landingBody.classList.add('hide');
            locationContinueContainer.style.display = 'none';
            locationContinueButton.style.display = 'none';

            setTimeout(() => {
                landingBody.style.display = 'none';
            }, 500);

            currDisplay = i;
            UpdateContent(tourData, pageData, contentBody, currDisplay);
        }
    }
};

export default CheckHashOnLoad;
